import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import VideoGrid from './components/VideoGrid';
import ArticleSection from './components/ArticleSection';
import { featuredVideos, latestVideos } from '@/mocks/videos';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <VideoGrid
          title="热门推荐"
          subtitle="全网热播，口碑爆棚的精选好片"
          videos={featuredVideos}
        />
        <VideoGrid
          title="最新更新"
          subtitle="每日更新，精彩不断"
          videos={latestVideos}
          compact
        />
        <ArticleSection />
      </main>
      <Footer />
    </>
  );
}